import { Form } from "@circle-react-uikit/Form";
import type { SpaceGroupPrefillData } from "@circle-react/components/Modals/NewSpaceGroupModal/types";

import { BasicInfo } from "./BasicInfo";
import { Permissions } from "./Permissions";
import { SpaceAccess } from "./SpaceAccess";
import type { NewSpaceGroupFormValues } from "./types";

interface NewSpaceGroupFormV3Props {
  formId: string;
  onSubmit: (values: NewSpaceGroupFormValues) => void;
  prefillData?: SpaceGroupPrefillData;
}

const DEFAULT_VALUES: NewSpaceGroupFormValues = {
  name: "",
  slug: "",
  hide_members_count: false,
  is_hidden_from_non_members: false,
  hide_non_member_spaces_from_sidebar: false,
  allow_members_to_create_spaces: false,
  automatically_add_members_to_new_spaces: false,
  add_members_to_space_group_on_space_join: false,
};

export const NewSpaceGroupFormV3 = ({
  formId,
  onSubmit,
  prefillData,
}: NewSpaceGroupFormV3Props) => (
  <Form<NewSpaceGroupFormValues>
    id={formId}
    onSubmit={onSubmit}
    defaultValues={{ ...DEFAULT_VALUES, ...prefillData }}
    formClassName="flex flex-col gap-4"
  >
    <BasicInfo />
    <Permissions />
    <SpaceAccess />
  </Form>
);
